module.exports = __webpack_public_path__ + "static/for-business-mob-2f331bda6798433757dbc5cd50ae7f03.jpg";